/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { Virtuoso } from 'react-virtuoso';

export const Container = styled.div`
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 100000;
  padding: 8px;
  box-shadow: 0px 16px 24px rgba(23, 43, 77, 0.04), 0px 16px 32px rgba(23, 43, 77, 0.08);
  background: #ffffff;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  border-radius: 4px;
  ${({ isOpen }) =>
    isOpen
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : css`
          visibility: hidden;
          opacity: 0;
        `}
  width: 347px;

  transition: all 0.2s linear;
`;

export const NoResultContainer = styled(Container)`
  height: 50px;
  line-height: 50px;
  padding-left: 10px;
  overflow: hidden;
`;

export const CampaignItem = styled.div`
  color: ${Palette.PrimaryGray._700};
  display: flex;
  justify-content: center;
  padding-left: 16px;

  flex-direction: column;
  height: 56px;
  border: 1px solid white;
  cursor: pointer;
  :hover {
    background: ${Palette.PrimaryGray._100};
  }

  ${({ isActive }) => {
    return (
      isActive &&
      css`
        border: 1px solid ${Palette.Primary._300};
      `
    );
  }}
`;

export const AppItem = styled.div`
  padding-left: 16px;
  height: 56px;
  width: 100%;
  display: flex;
  gap: 16px;
  cursor: pointer;
  align-items: center;
  border: 1px solid white;
  :hover {
    background: ${Palette.PrimaryGray._100};
  }
  ${({ isActive }) => {
    return (
      isActive &&
      css`
        border: 1px solid ${Palette.Primary._300};
      `
    );
  }}
`;

export const ImgBox = styled.div`
  min-width: 36px;
  min-height: 36px;
  max-width: 36px;
  max-height: 36px;
  img {
    width: 100%;
    border-radius: 4px;
  }
`;

export const Title = styled.p`
  color: ${Palette.PrimaryGray._400};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const CampNumberBox = styled.div`
  display: flex;
`;

export const Text = styled.p`
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const MyVirtuoso = styled(Virtuoso)`
  height: ${({ height }) => {
    if (height >= 400) return `400px!important`;
    if (height < 400) return `${height + 32}px!important`;
  }};
  ::-webkit-scrollbar {
    width: 6px;
    background-color: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${() => Palette.PrimaryGray._300};
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff;
  }
`;
